let appVersionMismatch = false;
export function checkForAppVersionMismatch(newVersion) {
    if (newVersion && window.__GLOBAL_CONTEXT__ && newVersion !== window.__GLOBAL_CONTEXT__.appVersion) {
        setTimeout(() => (appVersionMismatch = true), 20 * 60 * 1000);
    }
}
export function isAppVersionMismatch() {
    return appVersionMismatch;
}
